import classNames from 'classnames'
import { useAtom } from 'jotai'
import { MyForm } from '~/components/ui/MyForm'
import {
  cfgAtom,
  clipSkipAtom,
  ensdAtom,
  modelCodeAtom,
  optionsAtom,
  selectSamplerAtom,
} from './atom'
import styles from '../AiForm.module.css'
import { useEffect, useState } from 'react'
import { Col, Row } from 'antd'
import { MyIcon } from '~/components/ui/MyIcon'
import { isNullOrUndefined } from '~/utils'
import { getAIMenu_pictureGraph_aiCreateArtworkOptionMenu_patternModelOptions } from '~/graphqls/types'

const Item = ({ isActive, name }: { isActive: boolean; name: string }) => {
  return (
    <div
      className={classNames(
        'rounded-full text-neutral-800 font-semibold p-1 text-sm border-2 text-center cursor-pointer text-overflow',
        [[isActive ? 'border-neutral-500' : 'border-transparent']]
      )}
      style={{
        background: isActive
          ? 'radial-gradient(74.76% 334.54% at 49.84% 50%, #374176 0%, rgba(55, 65, 118, 0) 100%)'
          : '#23262F',
      }}
    >
      {name}
    </div>
  )
}

/** 默认显示数量 */
const DEFAULT_SHOW_COUNT = 8

export const LabModelCodeComp = () => {
  const [options] = useAtom(optionsAtom)
  const [modelCode, setModelCode] = useAtom(modelCodeAtom)
  const [, setSelectSampler] = useAtom(selectSamplerAtom)
  const [, setCfg] = useAtom(cfgAtom)
  const [, setEnsd] = useAtom(ensdAtom)
  const [, setClipSkip] = useAtom(clipSkipAtom)

  const [expand, setExpand] = useState(false)
  const showMore =
    (options?.patternModelOptions || [])?.length > DEFAULT_SHOW_COUNT
  const _options = (options?.patternModelOptions || [])?.slice(
    0,
    expand ? Infinity : DEFAULT_SHOW_COUNT
  )

  const handleClickOption = (
    item: getAIMenu_pictureGraph_aiCreateArtworkOptionMenu_patternModelOptions
  ) => {
    setModelCode(item.modelCode!)
    setCfg(item.cfg ?? undefined)
    setSelectSampler(
      isNullOrUndefined(item.samplerIndex) ? undefined : [item.samplerIndex!]
    )
    setEnsd(item.ensd ?? undefined)
    setClipSkip(item.clipSkip ?? undefined)
  }

  /** 默认选中第一个模型主题 */
  useEffect(() => {
    if (
      options!.patternModelOptions?.findIndex(
        item => item.modelCode === modelCode
      ) === -1
    ) {
      setModelCode(options!.patternModelOptions?.[0].modelCode!)

      setCfg(options!.patternModelOptions?.[0]?.cfg ?? undefined)
      setSelectSampler(
        isNullOrUndefined(options!.patternModelOptions?.[0]?.samplerIndex)
          ? undefined
          : [options!.patternModelOptions?.[0]?.samplerIndex!]
      )
      setEnsd(options!.patternModelOptions?.[0]?.ensd ?? undefined)
      setClipSkip(options!.patternModelOptions?.[0]?.clipSkip ?? undefined)
    }
  }, [options!.patternModelOptions])

  return (
    <MyForm.Item
      label="* 模型主题"
      className={classNames(styles.borderLessFormItem, '!mb-8')}
    >
      <Row gutter={12}>
        {_options.map(item => {
          const isActive = item.modelCode === modelCode
          return (
            <Col span={6} key={item.modelCode} className="mb-3">
              <div
                onClick={() => {
                  handleClickOption(item)
                }}
              >
                <Item isActive={isActive} name={item.name!} />
              </div>
            </Col>
          )
        })}
      </Row>
      {showMore && (
        <div
          className="w-10 h-7 bg-neutral-200 flex items-center justify-center rounded-full mx-auto cursor-pointer"
          onClick={() => {
            setExpand(!expand)
          }}
        >
          <MyIcon
            icon="arrow-down-simple"
            className={classNames('text-neutral-900 text-[24px]', {
              'rotate-180': expand,
            })}
          />
        </div>
      )}
    </MyForm.Item>
  )
}
